import * as List from '../../Utils/FunctionList'

const initialState = {
    typeOfModal: "",
    isModalOpen: false,
    metadata:{}
}


const setModalController = (state = initialState, action) => {
    console.log(action)
    if (
        action.type === List.SUPPORTED_FUNCTIONS.REPORT_MODAL
    ) {
        return {
            ...state,
            typeOfModal: action.typeOfModal,
            isModalOpen: action.isModalOpen,
            metadata: action.metadata
        }
    }
    else if(   action.type === List.SUPPORTED_FUNCTIONS.CLOSE_MODAL){
        return {
            ...state,
            typeOfModal: "",
            isModalOpen: false,
            metadata:{}
        }
    }


    return state;
};

export default setModalController